import { render } from "./LStatusMessage.vue?vue&type=template&id=368b2a7f"
import script from "./LStatusMessage.vue?vue&type=script&lang=js"
export * from "./LStatusMessage.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__